<footer class="text-center text-lg-start">
@if(showAll) {
  <section class="p-4 text-white">
    <div class="container text-center text-md-start mt-5">
      <div class="row mt-3">
        <div class="col-md-3 mx-auto mb-4">
          <img id="footer-logo" src="/assets/img/memorabid-logo-white.svg" alt="Logo" class="img-fluid mb-4" />

          <div class="d-flex justify-content-center p-4">
            @if(socialLinks().urlInstagram) {
            <a title="Instagram" href="{{socialLinks().urlInstagram}}" target="_blank" class="me-4 text-reset">
              <fa-icon [icon]="faInstagram"></fa-icon>
            </a>
            } @if(socialLinks().urlFacebook) {
            <a title="Facebook" href="{{socialLinks().urlFacebook}}" target="_blank" class="me-4 text-reset">
              <fa-icon [icon]="faFacebookF"></fa-icon>
            </a>
            } @if(socialLinks().urlTiktok) {
            <a title="TikTok" href="{{socialLinks().urlTiktok}}" target="_blank" class="me-4 text-reset">
              <fa-icon [icon]="faTikTok"></fa-icon>
            </a>
            } @if(socialLinks().urlTwitter) {
            <a title="Twitter" href="{{socialLinks().urlTwitter}}" target="_blank" class="me-4 text-reset">
              <fa-icon [icon]="faTwitter"></fa-icon>
            </a>
            } @if(socialLinks().urlLinkedin) {
            <a title="LinkedIn" href="{{socialLinks().urlLinkedin}}" target="_blank" class="text-reset">
              <fa-icon [icon]="faLinkedinIn"></fa-icon>
            </a>
            }
          </div>
          @if(!isBranded()) {
            <span class="payments-available mb-1 mt-3">{{"IDS_AVAILABLE_PAYMENTS" | translate}}</span>
            <img class="payments-footer" src="/assets/img/payments-footer.png" alt="payments" />
          }
        </div>

        @if(pagesCol1?.length) {
        <div class="col-md-3 mx-auto mb-4">
          @for (page of pagesCol1[0]?.pageGroupList; track page.languagePath) {
          <div class="footer-page-link">
            <a [routerLink]="page.languagePath">
              {{ page.idsPageName | translate }}
            </a>
          </div>
          }
        </div>
        } @if(pagesCol2?.length) {
        <div class="col-md-3 mx-auto mb-4">
          @if(!isBranded()) {
          <h6 class="certificate-validation">
            <button class="text-reset cert-button" type="button" (click)="certificateDialog()">
              {{"IDS_CERTIFICATE_VALIDATE" | translate}}
            </button>
          </h6>
          <h6 class="nameBecomeSeller">
            <a [routerLink]="currLang()+'/become-seller'" class="text-reset">{{"IDS_BECOME_SELLER" | translate}}</a>
          </h6>
        }
          <h6 class="text-uppercase mb-3 visually-hidden">Links</h6>
          @for (page of pagesCol2[0]?.pageGroupList; track page.pageRoute) {
          <div class="footer-page-link">
            @if(page.idsPageName==='IDS_COOKIE_POLICY') {
            <a [routerLink]="currLang()+'/'+page.pageRoute" class="iubenda-cs-preferences-link">
              {{ page.idsPageName | translate }}
            </a>
            } @if(page.idsPageName!=='IDS_COOKIE_POLICY') {
            <a [routerLink]="currLang()+'/'+page.pageRoute">
              {{ page.idsPageName | translate }}
            </a>
            }
          </div>
          }
        </div>
        }

        @if(!isBranded()) {
        <div class="col-md-3 mx-auto mb-4">
          <h6 class="text-uppercase mb-3">
            {{"IDS_NEWSLETTER" | translate}}
          </h6>
          <form (ngSubmit)="onSubmit()" #newsletterForm="ngForm" autocomplete="off">
            <p class="text-muted mb-4">
              {{"IDS_NEWSLETTER_UPDATE" | translate}}
            </p>
            <input type="text" placeholder="Email" name="email" id="email" [(ngModel)]="email" required />
            <label class="text-muted label-container text-privacy">
              <input class="input-checkbox" type="checkbox" checked="checked" name="subscribe" required />
              {{"IDS_ACCEPT" | translate}}
              <a class="privacy-policy" [routerLink]="currLang()+'/privacy-policy'">Privacy Policy</a>
              <span class="checkmark"></span>
            </label>
            <div>
              <button class="text-uppercase fw-bold" type="submit" [disabled]="!newsletterForm.valid">
                {{"IDS_SUBSCRIBE" | translate}}
              </button>
            </div>
          </form>
        </div>
      }
      </div>
    </div>
  </section>
  } @if(!isBranded() && !showAll) {
  <div class="row p-0 m-0">
    <div class="col-2 p-0 m-0"></div>
    <div class="col-8 logo-img px-3 py-5 m-0">
      <img src="/assets/img/memorabid-logo-white.svg" alt="Logo" />
    </div>
    <div class="col-2 p-0 m-0"></div>
  </div>
  }
  <div class="info-bottom text-center p-4 text-muted" [class.bottom-space]="!showAll">
    <p>
      <small>Memorabid | {{"IDS_RIGHTS" | translate}}<br />
        Memorabid Srl - Foro Buonaparte 59, 20121
        Milano - C.F./P.IVA {{appSettings?.taxId}}<br />
        {{"IDS_BUSINESS_REGISTER" | translate}}
        {{appSettings?.businessRegisterCode}} - {{"IDS_SHARE_CAPITAL" |
        translate}}{{appSettings?.socialCapital}} €
      </small>
    </p>
  </div>
</footer>
